<script setup lang="ts">
import DisplaySectionLabel from "./DisplaySectionLabel.vue";
import DisplayToolGroup from "./DisplayToolGroup.vue";
import { TOOLBAR_GROUPS } from "@/utils/toolbar-tools";

/** Colonne de droite : les outils affichés dans la barre, groupe par groupe. */
</script>

<template>
  <div>
    <DisplaySectionLabel>{{
      $t("canvas:display.sections.tools")
    }}</DisplaySectionLabel>
    <DisplayToolGroup
      v-for="group in TOOLBAR_GROUPS"
      :key="group.id"
      :group-id="group.id"
      :tools="group.tools"
    />
  </div>
</template>
